import { connect } from 'react-redux';
import YearsSavingView from './YearsSavingView';
import { updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_EDUCATION_GOAL_API } from '../ChildrenInfoWorkflowConstants';
import * as childrenSelector from '../ChildrenInfoWorkflowSelector';

const mapStateToProps = (state, ownProps) => {
  const clientId = childrenSelector.clientId(state, ownProps);
  const childFirstName = childrenSelector.getSelectedChildFirstName(state, ownProps);
  const goalsList = childrenSelector.getEducationGoalList(state, ownProps);
  const childEducationGoal = childrenSelector.getChildEducationGoal(goalsList, childFirstName);
  const isEditingGoal = !!childEducationGoal.Id;

  const inputYears = childrenSelector.getInputYears(state, ownProps) || '';
  const existingYears = childEducationGoal.Years;
  const hasYearsChanged =
    (!inputYears && inputYears === '') || (inputYears && inputYears.length > 0);
  const yearsSaving = hasYearsChanged ? inputYears : existingYears;

  const selectedEducationType =
    childrenSelector.getSelectedEducationType(state, ownProps) || childEducationGoal.EducationType;

  const updatedEducationGoalData = childrenSelector.getUpdatedEducationGoalData(state, ownProps);

  const educationGoal = {
    ...childEducationGoal,
    ...updatedEducationGoalData,
    ClientId: clientId,
    Years: yearsSaving,
    Name: childFirstName,
  };

  return {
    clientId,
    yearsSaving,
    isEditingGoal,
    educationGoal,
    selectedEducationType,
  };
};

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateSupportData(data, workflowId, clientId)),
  onPostProcess: (data, educationGoal) => ({
    [BACKEND_EDUCATION_GOAL_API]: educationGoal,
  }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(YearsSavingView);
